/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { fetchSensorData } from "../../../api/homeApi";
import { fetchSensorCount } from "../../../api/homeApi";
import { toast } from "react-toastify";


function useFetchSensorList(filter,pageSize,currentPage,order_by,order_dir) {

    const [data, setData] = useState({
        sensorList: [],
        sensorCount: 0
    });

    const offset = (currentPage - 1) * pageSize;
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        
   
       const fetchData = async () => {
         setLoading(true);
         try {
          const [sensorResponse, countResponse] = await Promise.all([
            fetchSensorData(filter, pageSize, offset, order_by, order_dir),
            fetchSensorCount(filter),
          ]);
          setData({
                  sensorList: sensorResponse,
                  sensorCount: countResponse,
                });
         } catch (err) {
           toast.error("Cannot fetch Sensor List");
           setError(err);
         } finally {
           setLoading(false);
         }
       };
   
       fetchData();
     }, [currentPage, order_by, order_dir, filter]);
     return { data, loading, error };
}


export default useFetchSensorList;